/* eslint-disable @typescript-eslint/no-explicit-any */
import { color } from 'asserts/styles/colors';

const useHorizontalBarStyle = () => {
  const getCustomBarTrack = (chart: any) => {
    const {
      ctx,
      data,
      chartArea: { left, width },
      scales: { y }
    } = chart;

    const barTickness = chart.getDatasetMeta(0).data[0].height;

    ctx.save();

    ctx.fillStyle = `${color.white005}`;

    data.datasets[0].data.forEach((_: any, index: number) => {
      ctx.fillRect(left, y.getPixelForValue(index) - barTickness / 2, width, barTickness);
    });
  };

  return getCustomBarTrack;
};

export default useHorizontalBarStyle;
